export const PREVIEW_CLASS_NAMES = {
  DESKTOP: 'preview-desktop',
  MOBILE: 'preview-mobile'
};
